import { LoadingPage } from '@chiroup/components/LoadingPage';
import { FlagGroups, flagGroupsArr } from '@chiroup/core/constants/flags';
import { FlagGroupClinic } from '@chiroup/core/types/FlagGroupClinic.type';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import flagService from '../../services/flag.service';
import Header from '../layout/Header';
import FlagsNavigation from './FlagsNavigation';

const FlagGroupClinics = () => {
  const {
    data = [],
    isLoading,
    error,
  } = useQuery<FlagGroupClinic[], Error>(['flags', 'clinics'], flagService.clinicsByGroup, {
    refetchOnWindowFocus: false,
  });
  const groups = Array.from(
    new Set([...flagGroupsArr.map(group => group.value), ...data.map(clinic => clinic.flagGroup)])
  ).filter(group => group !== FlagGroups.everyone);

  return (
    <>
      <Header title="Feature flags" />
      <FlagsNavigation active="clinics" />
      {isLoading ? (
        <LoadingPage />
      ) : error ? (
        <p className="m-6 text-sm text-red-700" role="alert">
          Could not load clinics by flag group: {error.message}
        </p>
      ) : (
        <div className="m-6 space-y-6">
          {groups.map(group => {
            const clinics = data.filter(clinic => clinic.flagGroup === group);
            const label = flagGroupsArr.find(item => item.value === group)?.label || group;

            return (
              <section
                key={group}
                className="overflow-hidden rounded-lg bg-white shadow ring-1 ring-black/5"
              >
                <h2 className="border-b border-gray-200 bg-gray-50 px-6 py-4 text-base font-semibold text-gray-900">
                  {label} ({clinics.length})
                </h2>
                {clinics.length ? (
                  <ul className="divide-y divide-gray-200">
                    {clinics.map(clinic => (
                      <li key={clinic.clinicId}>
                        <Link
                          to={`/clinics/${clinic.clinicId}`}
                          className="block px-6 py-3 text-sm text-primary-600 hover:bg-gray-50 hover:underline"
                        >
                          {clinic.clinicName || 'Primary location missing'} ({clinic.clinicId})
                        </Link>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="px-6 py-4 text-sm text-gray-500">No clinics in this group.</p>
                )}
              </section>
            );
          })}
        </div>
      )}
    </>
  );
};

export default FlagGroupClinics;
